import type { DurableConversation } from "@/api/conversations";
import { translate } from "@/i18n";
import { libChatMessages } from "@/i18n/messages/lib-chat";

const INTERNAL_EXECUTION_TITLE =
  /^\[(?:session|exec):[0-9a-f-]+\]\s+Execution$/i;
export const CONVERSATION_FRAME_TITLE_MAX_LENGTH = 30;

/** The backend titles an untitled chat "New chat"; the app shows its own
 *  words for it, in the app language. */
export function isUntitledChatTitle(title: string | null | undefined): boolean {
  const trimmed = title?.trim();
  return !trimmed || trimmed === "New chat";
}

function shownTitle(title: string | null | undefined): string | null {
  const trimmed = title?.trim();
  return trimmed &&
    !isUntitledChatTitle(trimmed) &&
    !INTERNAL_EXECUTION_TITLE.test(trimmed)
    ? trimmed
    : null;
}

/** A task chat is a Denker helper's run, named "Denker helper · <task>". */
export function conversationDisplayName(
  conversation: Pick<DurableConversation, "title"> &
    Partial<Pick<DurableConversation, "display_title" | "context_kind">>,
): string {
  const title =
    shownTitle(conversation.display_title) ?? shownTitle(conversation.title);
  if (!title) return translate(libChatMessages, "newChat");
  return conversation.context_kind === "task"
    ? `${translate(libChatMessages, "denkerHelper")} · ${title}`
    : title;
}

export function conversationFrameDisplayTitle(title: string): string {
  const characters = Array.from(title);
  if (characters.length <= CONVERSATION_FRAME_TITLE_MAX_LENGTH) return title;
  return `${characters
    .slice(0, CONVERSATION_FRAME_TITLE_MAX_LENGTH - 1)
    .join("")}…`;
}
